import { apiHolder as api } from 'api';
import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig, taskMailMenuShow } from '../util';
import { getIn18Text } from 'api';
import { getMailFromMails } from '@web-mail/util';
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
const MailListMenuConfig = [
    {
        key: MAIL_MENU_ITEM.RE_EDIT,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.MAIL_WITHDRAW,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.MAIL_WITHDRAW_RES,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ATTACH,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ATTACH_ALL,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL_AS_NEW,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.FORWARD,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.RED_FLAG,
        show: taskMailMenuShow,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.READ,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.TAG,
        show: taskMailMenuShow,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.WMFOLLOW,
        show: taskMailMenuShow,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.DEFER,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.COMMENT,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.MOVE,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.TOP,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.DIRECT_DELETE,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.REPORT,
        group: '4',
    },
    {
        key: MAIL_MENU_ITEM.REPORT_TRUST,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.TRANSLATE,
        group: '5',
    },
    {
        key: MAIL_MENU_ITEM.SEARCH_IN_CONTENT,
        group: '5',
    },
    {
        key: MAIL_MENU_ITEM.SHARE,
        group: '6',
    },
    {
        key: MAIL_MENU_ITEM.DISCUSSION,
        group: '6',
    },
    {
        key: 'more',
        group: '7',
        onlyUnfold: true,
        name: getIn18Text('GENGDUO'),
        show: true,
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.FORWARD_BY_ATTACH,
                group: '1',
            },
            {
                key: MAIL_MENU_ITEM.DELIVERY,
                group: '1',
                show: (mails, defaultShow) => {
                    var _a;
                    const mail = getMailFromMails(mails);
                    if (!(process.env.BUILD_ISEDM || ((_a = systemApi === null || systemApi === void 0 ? void 0 : systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion))) {
                        return !!defaultShow && defaultShow(mail);
                    }
                    return false;
                },
                onClick: (mails, defaultClickFn) => {
                    const mail = getMailFromMails(mails);
                    const { entry: { id, threadMessageFirstId }, _account, isThread, } = mail;
                    let mailId = id;
                    if (isThread) {
                        mailId = threadMessageFirstId;
                    }
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            mailId,
                            account: _account,
                            way: 'mailDetail',
                        },
                        eventStrData: 'delivery',
                    });
                    defaultClickFn && defaultClickFn(mail);
                },
            },
            {
                key: MAIL_MENU_ITEM.SET_FROM_GROUP,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.CREATE_PERSONAL_GROUP,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.OPEN_IN_WINDOW,
                group: '3',
            },
            {
                key: MAIL_MENU_ITEM.PRINT_MAIL_PREVIEW,
                group: '3',
            },
            {
                key: MAIL_MENU_ITEM.PRINT_MAIL,
                group: '3',
            },
            {
                key: MAIL_MENU_ITEM.EXPORT,
                group: '3',
            },
            {
                key: MAIL_MENU_ITEM.ENCODING,
                group: '3',
            },
            {
                key: MAIL_MENU_ITEM.EMAIL_HEADER,
                group: '3',
            },
        ], DefaultMailMenuConfig),
    },
];
export default findAndMergeDefaultMenuConfig(MailListMenuConfig, DefaultMailMenuConfig);
